import React from "react";
import PropTypes from "prop-types";
import RtrButton from "components/design-system/rtr-button";

class ItemUnavailable extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    sku: PropTypes.shape({
      size: PropTypes.string,
    }),
    unexpectedError: PropTypes.string,
    remaining: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    useNewGrid: PropTypes.bool,
  };

  getCopy = () => {
    var copy;

    // TODO: Investigate whether we still generate this.props.unexpectedError anywhere
    if (this.props.unexpectedError) {
      copy = "This item is unavailable for your zip and date.";
    } else if (parseInt(this.props.remaining) === 0) {
      copy = "This item is unavailable";
    } else {
      copy = this.props.sku ? "Size " + this.props.sku.size : "This item";
      copy = copy + " is fully booked on selected dates.";
    }
    return copy;
  };

  getSimilarUrl = () => {
    if (this.props.useNewGrid) {
      return `/shop/${this.props.id.toLowerCase()}_similar_styles/products`;
    }
    return "/similar/" + this.props.id + "/products";
  };

  render() {
    return (
      <div data-test-id="item-unavailable">
        <p className="text-mutedRed my-4">{this.getCopy()}</p>

        <RtrButton style="secondary" fullWidth href={this.getSimilarUrl()}>
          Shop similar styles
        </RtrButton>
      </div>
    );
  }
}

export default ItemUnavailable;
